import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import FreeTrialOnboarding from 'pages/FreeTrialActivation/components/FreeTrailOnboarding';
import TrialLandingSVG from 'assets/TrialLanding.svg';
import HIPAAComplaintSVG from 'assets/HIPAAComplaint.svg';
import theme from 'theme';
import { LogoUrl, MixpanelEventName } from 'utils/constants';
import { trackMixpanelEvent } from 'utils/utilMethods';
import { useNavigate } from 'react-router-dom';
import { auth } from 'utils/spaUrls';

function TrailLandingPage() {
  const handleTryHeadlamp = () => {
    trackMixpanelEvent(MixpanelEventName.TRIAL_LANDING_TRY_HEADLAMP_BUTTON_CLICKED);
    setShowOnboarding(true);
  };

  const handleTryHeadlampForFree = () => {
    trackMixpanelEvent(MixpanelEventName.TRIAL_LANDING_TRY_HEADLAMP_FOR_FREE_BUTTON_CLICKED);
    setShowOnboarding(true);
  };
  const navigate = useNavigate();
  const [showOnboarding, setShowOnboarding] = useState(false);

  if (showOnboarding) {
    return <FreeTrialOnboarding />;
  }

  const navigateToSignIn = () => {
    trackMixpanelEvent(MixpanelEventName.TRIAL_LANDING_SIGN_IN_BUTTON_CLICKED);
    navigate(auth.login);
  };

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        background: 'linear-gradient(180deg, #E0F1FF 0%, #F4FAFF 97.6%)',
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 10,
        overflow: 'hidden',
      }}
    >
      {/* Sticky Header */}
      <AppBar
        position='sticky'
        elevation={0}
        sx={{ background: 'white', boxShadow: 'none', height: 80 }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', height: 80 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <input
              type='image'
              height={theme.custom.logoHeight}
              width={theme.custom.logoWidth}
              src={LogoUrl.lg}
              alt='Logo'
              onClick={() => window.open('https://www.headlamp.com', '_blank')}
              style={{ cursor: 'pointer' }}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 5 }}>
            <Button
              variant='text'
              sx={{ color: '#0288D1', fontWeight: 400 }}
              onClick={navigateToSignIn}
            >
              SIGN IN
            </Button>
            <Button
              variant='contained'
              onClick={handleTryHeadlamp}
              sx={{
                display: { xs: 'none', md: 'block' },
                fontWeight: 500,
                borderRadius: 999,
                background: '#03A9F4',
                '&:hover': { background: '#0288D1' },
                px: 6,
              }}
            >
              TRY HEADLAMP
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          px: { xs: 2, md: 3 },
          pt: { xs: 4, md: 7.5 },
          overflow: 'auto',
        }}
      >
        <Box display='flex' gap={6} flexDirection={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'center', md: 'flex-start' }}>
          {/* Left Section */}
          <Box
            flex={1}
          >
            <Typography
              variant='h1'
              fontWeight={300}
              mb={6}
              color={theme.custom.colors.lightTextPrimary}
            >
              Session Prep, Done
              for You
            </Typography>
            <Typography
              variant='h4'
              fontWeight={400}
              mb={6}
              color={theme.custom.colors.lightTextPrimary}
            >
              Meds, labs, symptoms, mood, and sleep —
              all ready before your first patient visit. Walk in prepared, not in chaos.
            </Typography>
            <Button
              variant='contained'
              size='large'
              sx={{
                mb: 6,
                borderRadius: 999,
                fontWeight: 500,
                background: '#03A9F4',
                '&:hover': { background: '#0288D1' },
                px: 6,
              }}
              onClick={handleTryHeadlampForFree}
            >
              TRY HEADLAMP FOR FREE
            </Button>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <img
                src={HIPAAComplaintSVG}
                alt='HIPAA Compliant'
                style={{ height: 75, width: 150 }}
              />
            </Box>
          </Box>
          {/* Right Section */}
          <Box flex={1}>
            <img
              src={TrialLandingSVG}
              alt='Session Prep Preview'
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </Box>
        </Box>
        <Box display='flex' flexDirection='column' alignItems='center' pb={7.5}>
          <Typography
            variant='h5'
            mt={11}
            color={theme.custom.colors.lightTextPrimary}
            fontWeight={400}
            textAlign='center'
          >
            Headlamp is Trusted by 1000s of Patients, Clinicians, & Researchers across 42+ states
          </Typography>
          <Typography variant='body2' mt={3} color='#252525'>
            ©2025 Headlamp Health, Inc. All Rights Reserved
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default TrailLandingPage;
